import { editableChannelsSchema } from './schemas'

import type { z } from 'zod'

export type EditableChannel = z.infer<typeof editableChannelsSchema>

/**
 * Ordered, readonly tuple of channels rendered in the settings UI. Mirrors the
 * display order of the wireframe.
 */
export const EDITABLE_CHANNELS = editableChannelsSchema.options

/**
 * UX copy for each editable channel. Keyed by channel identifier so the card
 * component stays declarative.
 */
export const CHANNEL_METADATA: Record<
	EditableChannel,
	{ label: string; description: string }
> = {
	alerts: {
		label: 'Cases',
		description: 'Receive notifications when cases are created.',
	},
	air_user_management: {
		label: 'AIR® User Management',
		description: 'Receive notifications when a new user is created.',
	},
	automation: {
		label: 'Automation',
		description: 'Receive notifications when playbooks are created.',
	},
	platform: {
		label: 'Platform',
		description: 'Receive notifications when the platform is updated.',
	},
	reports: {
		label: 'Reports',
		description: 'Receive notifications when reports are generated.',
	},
}
